module.exports = __webpack_public_path__ + "img/card-everyone.e90afe14.jpg";